import { useFrame } from '@react-three/fiber'
import { PerspectiveCamera } from '@react-three/drei'
import { useRef, useEffect, useState} from 'react'
import { motion } from "framer-motion-3d"
import { useMotionValue, animate } from "framer-motion";
import Calendar from '../scene/calendar2.jsx'
import Floor from '../scene/floor.jsx'
import Coffee from '../scene/coffeeMC.jsx'
import dateFormat from "dateformat";
import Fan from '../scene/fan.jsx'
import Notebook from '../scene/notebook.jsx'
import JoyStick from '../scene/joystick.jsx'
import Pencil from '../scene/pencil.jsx'


export default function Experience({isDark, showAbout, wall, setWall})
{
    const date = [dateFormat(new Date(), 'ddd').toUpperCase(),dateFormat(new Date(), 'dd').toUpperCase(),dateFormat(new Date(), 'mmm').toUpperCase()]
    const deg= Math.PI*2/360
    const colors = {'day':"#000fff",'day2':"#000888", "night":"#9d72f7","night2":"#3D2D70", "bg":"#121212", "white":"#dddddd", "shadowDay":"#111111","shadowNight":"#000000"}
    const world = useRef()
    const camera = useRef()
    const cameraOrbit = useRef()
    const cameraElev = useRef()

    const [canvasSize, setCanvasSize] = useState({x:window.innerWidth,y:window.innerHeight, zIndex:1})
    const [mousePos, setMousePos] = useState({x:0,y:0})
    const [normalPos, setNormalPos] = useState({x:0,y:0})
    const [counter, setCounter] = useState(1)
    const [mouseReact, setMouseReact] = useState(false)
    
    const fov = useMotionValue(0.35);
     

    let fanRot = 0

    useFrame((state, delta) =>
    {

        cameraOrbit.current.rotation.y =  mouseReact?((((cameraOrbit.current.rotation.y - (deg * normalPos.x * 1)) * 0.8) - (deg*3)) * (showAbout?counter:1)) + -0.5*deg : -0.26
        // cameraOrbit.current.rotation.y = -90*deg
        cameraOrbit.current.position.x = normalPos.x*-0.01
        // cameraOrbit.current.position.z = normalPos.y*0.01

        fanRot += 0.1*deg
  
      
        if(showAbout){
          if(counter>0){
            setCounter(counter-0.03)
          }
        }
        if(showAbout===false){
          setCounter(1)
        }
      
    })
  

    // Mouse Movement
      useEffect(()=>{
        setNormalPos( {x:( mousePos.x / (canvasSize.x/2)  -1), y : (mousePos.y/(canvasSize.y/2)  -1)})
        
      },[mousePos])
      

    useEffect(() => {
      const handleMouseMove = (event) => {
        setMousePos({ x: event.clientX, y: event.clientY });
      }
      window.addEventListener('mousemove', handleMouseMove);
    }, [])

    useEffect(() => {
      setWall(false)
    },[])
    
    setTimeout(()=>{setMouseReact(true)},1000)
    
    useEffect(() => {
    animate(fov, 1, { duration: 1, ease: [0.76, 0, 0.24, 1] });
    }, []);

    useFrame(() => {
    if (camera.current) {
      camera.current.fov = fov.get();
      camera.current.updateProjectionMatrix();
    }
    });

    return <>
   
        <motion.group ref={cameraOrbit} position-x={0} position-y={0} position-z={0}  animate={{x: showAbout?0:0, z: showAbout?-0.15:0 }}  transition={{ ease: "easeInOut", duration: 1}} >
          <motion.group ref={cameraElev} rotation-x={-40*deg} animate={{x: showAbout?0.03:0, y:showAbout?0:0, z: showAbout?0:0 ,rotateX:showAbout?-30*deg:-20*deg}}  transition={{ ease: "easeInOut", duration: 1}}>
        
          <PerspectiveCamera makeDefault  
                    fov= {fov}
                    near= {0.1}
                    far= {200}
                    position= {[ 0,0,19]}
                    ref={ camera } 
                />
          </motion.group>
        </motion.group>

     
        <Floor isDark={isDark} colors={colors} position={[0,0,0]}/>
  
        <JoyStick isDark={isDark} date={date} colors={colors} normalPos={normalPos} position={[-0.235,0,0.35]} rotation={[0,0,0]} scale={2}/>
      
        <Calendar isDark={isDark} date={date} colors={colors} position={[-0.135,0,-0.125]} rotation={[0,0,0]} scale={1.1}/>
        
        <Notebook isDark={isDark} date={date} colors={colors} position={[0.09,0,-0.4]} rotation={[0,0,0]} scale={1.8}/>
        
        <Pencil isDark={isDark} colors={colors} position={[0.22,0,-0.185]} rotation={[0,-90*deg,0]} scale={1.3}/>

        {/* <motion.group position={[-0.25,0,0.2]}>
           <Coffee isDark={isDark} colors={colors}/>
        </motion.group> */}
       
        
        <Fan isDark={isDark} colors={colors} position={[-0.175,0,-0.3]} fanRot scale={2}/>

       

    </>
} 